import { Directive } from '@angular/core';

/**
 * Marker directive for the table-rows slot of `umss-data-view`.
 *
 * Usage:
 * ```html
 * <ng-container umssDataViewRows>
 *   @for (item of dataSource.items; track item.id) {
 *     <tr class="my-row">...</tr>
 *   }
 * </ng-container>
 * ```
 */
@Directive({
  selector: '[umssDataViewRows]',
  standalone: true
})
export class UmssDataViewRowsDirective {}
